import { TwinPrompt } from 'api/model'
import { useActiveOrganization } from './use-organization'
import { useLayoutEffect, useState } from 'react'
import { twinsPrompts } from 'api/endpoints/jelledFromFileSpecWithTransformer'

function useFetchTwinPrompts(reloadKey: number) {
  const [activeOrganization] = useActiveOrganization()
  const [twinPrompts, setTwinPrompts] = useState<TwinPrompt[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useLayoutEffect(() => {
    async function fetchData() {
      if (!activeOrganization) {
        return
      }

      setIsLoading(true)

      try {
        const response = await twinsPrompts(activeOrganization)
        if (response.data) {
          setTwinPrompts(response.data)
        }
      } catch (error) {
        setError(`${error}`)
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
  }, [activeOrganization, setTwinPrompts, reloadKey])

  return {
    isLoading,
    twinPrompts,
    error,
    setTwinPrompts,
  }
}

export { useFetchTwinPrompts }
